import { render, staticRenderFns } from "./HotRecommend.vue?vue&type=template&id=7e94bd12&"
import script from "./HotRecommend.vue?vue&type=script&lang=js&"
export * from "./HotRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports